import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RangeSlider from 'react-rangeslider';
import { addVAT } from './utils';

export default class PaymentTermsTab extends PureComponent {

  constructor(props) {
    super(props);
    this.onChangeAcquisitionPrice = this.onChangeAcquisitionPrice.bind(this);
    this.onChangeTradeInIncVAT = this.onChangeTradeInIncVAT.bind(this);
    this.onChangeDownPayment = this.onChangeDownPayment.bind(this);
    this.onChangeInterest = this.onChangeInterest.bind(this);
    this.onChangeTerm = this.onChangeTerm.bind(this);
    this.onChangePeriodicity = this.onChangePeriodicity.bind(this);
    this.onSetupFeeChanged = this.onSetupFeeChanged.bind(this);
    this.onAdministrationFeeChanged = this.onAdministrationFeeChanged.bind(this);
  }
  onChangeTradeInIncVAT(tradeInIncVAT) {
    this.props.onChangeTradeInIncVAT(tradeInIncVAT);
  }

  onChangeDownPayment(downPayment) {
    this.props.onChangeDownPayment(downPayment);
  }

  onChangeAcquisitionPrice(acquisitionPrice) {
    this.props.onChangeAcquisitionPrice(acquisitionPrice);
  }

  onChangeInterest(interest) {
    this.props.onChangeInterest(interest);
  }

  onChangeTerm(term) {
    this.props.onChangeTerm(term);
  }

  onChangePeriodicity(event) {
    this.props.onChangePeriodicity(event.target.value);
  }

  onSetupFeeChanged(event) {
    this.props.onSetupFeeChanged(event.target.value);
  }

  onAdministrationFeeChanged(event) {
    this.props.onAdministrationFeeChanged(event.target.value);
  }

  render() {
    const t = this.props.t;
    const formatter = this.props.formatter;
    const percentFormatter = this.props.percentFormatter;
    return (<div className={`${this.props.classPrefix}-payment-terms-tab`}>
      <form>
        <div className={`${this.props.classPrefix}-acquisition-price`}>
          <div>{t('Acquisition price excl. VAT:')}</div>
          <div><RangeSlider tooltip={false} className={`${this.props.classPrefix}-rangeslider`} min={0} max={this.props.maxAcquisitionPrice} step={this.props.stepAcquisitionPrice} value={this.props.acquisitionPrice} onChange={this.onChangeAcquisitionPrice} format={formatter} /></div>
          <div><span className={`${this.props.classPrefix}-price`}>{formatter(this.props.acquisitionPrice)}</span> <span className={`${this.props.classPrefix}-price-vat`}>{t('inc. VAT')} {formatter(addVAT(this.props.acquisitionPrice, this.props.vat))}</span></div>
        </div>
        <div className={`${this.props.classPrefix}-trade-in`}>
          <div>{t('Trade-in excl. VAT:')}</div>
          <div><RangeSlider tooltip={false} className={`${this.props.classPrefix}-rangeslider`} min={0} max={this.props.maxTradeInIncVAT} step={this.props.stepTradeInIncVAT} value={this.props.tradeInIncVAT} onChange={this.onChangeTradeInIncVAT} format={formatter} /></div>
          <div><span className={`${this.props.classPrefix}-price`}>{formatter(this.props.tradeInIncVAT)}</span> <span className={`${this.props.classPrefix}-price-vat`}>{t('inc. VAT')} {formatter(addVAT(this.props.tradeInIncVAT, this.props.vat))}</span></div>
        </div>
        <div className={`${this.props.classPrefix}-down-payment`}>
          <div>{t('Down payment:')}</div>
          <div><RangeSlider tooltip={false} className={`${this.props.classPrefix}-rangeslider`} min={0} max={this.props.maxDownPayment} step={this.props.stepDownPayment} value={this.props.downPayment} onChange={this.onChangeDownPayment} format={formatter} /></div>
          <div> {formatter(this.props.downPayment)} </div>
        </div>
        <div className={`${this.props.classPrefix}-credit-amount`}>
          <div>{t('Credit amount (inc. VAT):')}</div>
          <div> {formatter(this.props.creditAmount)} </div>
          <div/>
        </div>
        <div className={`${this.props.classPrefix}-interest`}>
          <div>{t('Interest:')}</div>
          <div><RangeSlider tooltip={false} className={`${this.props.classPrefix}-rangeslider`} min={this.props.minInterest} max={this.props.maxInterest} step={this.props.stepInterest} value={this.props.interest} onChange={this.onChangeInterest} format={formatter} /></div>
          <div>{percentFormatter(this.props.interest)}</div>
        </div>
        <div className={`${this.props.classPrefix}-term`}>
          <div>{t('Term:')}</div>
          <div><RangeSlider tooltip={false} className={`${this.props.classPrefix}-rangeslider`} min={0} max={this.props.maxTerms} step={this.props.stepTerms} value={this.props.term} onChange={this.onChangeTerm} /></div>
          <div>{this.props.term} {t('Months')}</div>
        </div>
        <div className={`${this.props.classPrefix}-periodicity`}>
          <div>{t('Periodicity:')}</div>
          <div>
            <label>
              <input
                type="radio"
                name="periodicity"
                value="month"
                onChange={this.onChangePeriodicity}
                checked={this.props.periodicity === 'month'}
                        />
              {t('Month payment')}
            </label>
            <label>
              <input
                type="radio"
                name="periodicity"
                value="quarter"
                onChange={this.onChangePeriodicity}
                            checked={this.props.periodicity === 'quarter'} />
              {t('Quarter payment')}
            </label>
          </div>
        </div>
      </form>
      <div className={`${this.props.classPrefix}-period-expense`}>
        <h3>{t('Period expense')}</h3>
        <div className={`${this.props.classPrefix}-amounts`}>
          <div className={`${this.props.classPrefix}-amortization-amount`}>
            <div>{t('Amortization amount:')}</div>
            <div><span className={`${this.props.classPrefix}-amount`}>{formatter(this.props.amortizationAmount)}</span></div>
          </div>
          <div className={`${this.props.classPrefix}-payment-first-month`}>
            <div>{t('Payment month 1 inc interest:')}</div>
            <div><span className={`${this.props.classPrefix}-amount`}>{formatter(this.props.paymentMonthOneIncludingInterest)}</span></div>
          </div>
          <div className={`${this.props.classPrefix}-increased-amortization-amount`}>
            <div>{t('Increased amortization month 3 / 1:st quarter:')}</div>
            <div><span className={`${this.props.classPrefix}-amount`}>{formatter(this.props.increasedAmortizationAmount)}</span></div>
          </div>
          <div className={`${this.props.classPrefix}-increased-amortization-amount-description`}>
            <div>{t('(refers to the amount of VAT / one-time collection)')}</div>
          </div>
        </div>
        <div className={`${this.props.classPrefix}-fees`}>
          <div className={`${this.props.classPrefix}-setup-fee`}>
            <div>{t('Setup fee:')}</div>
            <div> <input type="text" value={this.props.setupFee} onChange={this.onSetupFeeChanged} /> </div>
          </div>
          <div className={`${this.props.classPrefix}-administration-fee`}>
            <div>{t('Administration fee:')}</div>
            <div> <input type="text" value={this.props.administrationFee} onChange={this.onAdministrationFeeChanged} /> </div>
          </div>
        </div>
      </div>
    </div>);
  }
}

PaymentTermsTab.propTypes = {
  t: PropTypes.func.isRequired,
  formatter: PropTypes.func.isRequired,
  percentFormatter: PropTypes.func.isRequired,
  currency: PropTypes.object.isRequired,
  acquisitionPrice: PropTypes.number.isRequired,
  tradeInIncVAT: PropTypes.number.isRequired,
  downPayment: PropTypes.number.isRequired,
  creditAmount: PropTypes.number.isRequired,
  interest: PropTypes.number.isRequired,
  term: PropTypes.number.isRequired,
  periodicity: PropTypes.string.isRequired,
  classPrefix: PropTypes.string.isRequired,
  setupFee: PropTypes.number.isRequired,
  administrationFee: PropTypes.number.isRequired,
  maxCreditAmount: PropTypes.number.isRequired,
  vat: PropTypes.number.isRequired,
  cooperationName: PropTypes.string.isRequired,
  maxAcquisitionPrice: PropTypes.number.isRequired,
  maxTradeInIncVAT: PropTypes.number.isRequired,
  maxDownPayment: PropTypes.number.isRequired,
  minInterest: PropTypes.number.isRequired,
  maxInterest: PropTypes.number.isRequired,
  maxTerms: PropTypes.number.isRequired,
  stepAcquisitionPrice: PropTypes.number.isRequired,
  stepTradeInIncVAT: PropTypes.number.isRequired,
  stepDownPayment: PropTypes.number.isRequired,
  stepInterest: PropTypes.number.isRequired,
  stepTerms: PropTypes.number.isRequired,
  amortizationAmount: PropTypes.number.isRequired,
  paymentMonthOneIncludingInterest: PropTypes.number.isRequired,
  increasedAmortizationAmount: PropTypes.number.isRequired,
  onChangeTradeInIncVAT: PropTypes.func.isRequired,
  onChangeDownPayment: PropTypes.func.isRequired,
  onChangeAcquisitionPrice: PropTypes.func.isRequired,
  onChangeInterest: PropTypes.func.isRequired,
  onChangeTerm: PropTypes.func.isRequired,
  onChangePeriodicity: PropTypes.func.isRequired,
  onSetupFeeChanged: PropTypes.func.isRequired,
  onAdministrationFeeChanged: PropTypes.func.isRequired,
};
